<p-toast></p-toast>

<div class="ns-header">
  <h2 class="ns-title">Notification Preferences</h2>
  <p class="ns-subtitle">Choose which types of notifications you receive.</p>
</div>

<div class="ns-card">
  <!-- Loading -->
  <div *ngIf="loading" class="ns-loading">
    <p-progressSpinner
      strokeWidth="3"
      [style]="{ width: '32px', height: '32px' }">
    </p-progressSpinner>
  </div>

  <!-- Settings list -->
  <div *ngIf="!loading" class="ns-list">
    <div *ngFor="let row of settings" class="ns-row">

      <!-- Type icon -->
      <div class="ns-row-icon" [ngClass]="row.bgClass">
        <i [class]="row.icon"></i>
      </div>

      <!-- Label + description -->
      <div class="ns-row-body">
        <div class="ns-row-label">{{ row.label }}</div>
        <div class="ns-row-desc" *ngIf="row.description">{{ row.description }}</div>
      </div>

      <!-- Toggle -->
      <p-inputSwitch
        [(ngModel)]="row.enabled"
        [name]="row.type"
        (onChange)="onToggle()"
        [disabled]="saving">
      </p-inputSwitch>

    </div>
  </div>
</div>
